import {
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonImg,
  IonPage,
  IonRouterLink,
  IonTitle,
  IonToolbar,
  useIonRouter,
} from "@ionic/react"
import { add } from "ionicons/icons"
import { DrawingId } from "../entities"
import { Session } from "../Session"
import { Authenticated, useMutation, useQuery } from "convex/react"
import { api } from "../convex/_generated/api"
import { HomePageContent } from "../components/HomePageContent"
import { useState } from "react"
import { ConfirmationDialog } from "../components/ConfirmationDialog"
import { useUser } from "@clerk/clerk-react"

export function HomePage() {
  const currentUser = useUser()
  const [drawingToDelete, setDrawingToDelete] = useState<null | DrawingId>(null)

  const drawings =
    useQuery(
      api.drawings.listDrawings,
      currentUser.isLoaded && currentUser.isSignedIn ? {} : "skip",
    ) ?? []

  const deleteDrawing = useMutation(api.drawings.deleteDrawing)

  const insertDrawing = useMutation(api.drawings.insertDrawing)

  const ionRouter = useIonRouter()

  async function handleDeleteDrawing(drawingId: DrawingId) {
    deleteDrawing({ drawingId })
    setDrawingToDelete(null)
  }
  return (
    <IonPage id="main-content">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonRouterLink routerLink="/home">
              <IonImg
                src="logo.svg"
                alt="logo"
                style={{ width: "40px", height: "40px", marginLeft: "15px" }}
              />
            </IonRouterLink>
            <IonTitle>Live Draw</IonTitle>
          </IonButtons>

          <IonButtons slot="end" style={{ marginRight: "15px" }}>
            <Session />
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <HomePageContent
          drawings={drawings}
          onDeleteDrawing={(drawingId) => setDrawingToDelete(drawingId)}
        />
      </IonContent>
      <Authenticated>
        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton
            onClick={async () => {
              const newDrawing = await insertDrawing({
                name: "New Drawing",
              })
              ionRouter.push(`/drawing/${newDrawing}`)
            }}
          >
            <IonIcon icon={add} />
          </IonFabButton>
        </IonFab>
      </Authenticated>
      <ConfirmationDialog
        title={`Delete ${drawings.find((d) => d._id === drawingToDelete)?.name}`}
        onSubmit={() => handleDeleteDrawing(drawingToDelete!)}
        open={Boolean(drawingToDelete)}
        onCancel={() => setDrawingToDelete(null)}
        submitLabel="Delete"
      >
        {`Are you sure you want to delete 
          ${drawings.find((d) => d._id === drawingToDelete)?.name}?`}
      </ConfirmationDialog>
    </IonPage>
  )
}
